import { createSlice } from '@reduxjs/toolkit';
import { initialFields } from './courseFormFields';


const initialState = {
  fields: initialFields,
};

const courseFormSlice = createSlice({
  name: 'courseForm',
  initialState,
  reducers: {
    setFields(state, action) {
      state.fields = action.payload;
    },
    resetFields(state) {
      state.fields = initialFields;
    }
  },
});

export const { setFields, resetFields } = courseFormSlice.actions;
export default courseFormSlice.reducer;